module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.11251/images/gswh-star.png"